import { css } from '@lastbrand/web-ui-styled-system/css'

// Figma: Quince Design System 2.0 → Widgets → ProductPrice (node 8529:107000).
// The Figma `breakpoint` prop maps to responsive tokens: mobile prices are body-20,
// desktop prices body-18 (mobile is the larger size). The container/price style pairs
// are mutually exclusive per variant (picked in product-price-ds.tsx); merging them
// with cx() is unreliable because Panda emits one class per property value and
// stylesheet order, not cx() order, decides.

export const containerCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  width: 'full',
})

export const containerDoubleCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  gap: { base: 'space-40', lg: 'space-48' },
  width: 'full',
})

// Double segments hug their content per Figma (no grow); minWidth 0 still lets long
// captions wrap instead of overflowing on narrow viewports ("too long texts will wrap").
export const segmentCss = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: 'space-4',
  minWidth: 0,
})

export const segmentGrowCss = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: 'space-4',
  flex: '1 0 0%',
  minWidth: 0,
})

// Price row + tags; tags wrap under the price when the row runs out of space.
export const wrapperCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  columnGap: 'space-8',
  rowGap: 'space-2',
  width: 'full',
})

// Strike + promo/bundle price group — stays on one line while tags wrap.
export const headerRowCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
})

export const priceCss = css({
  textStyle: { base: 'body-20', lg: 'body-18' },
  color: 'black',
})

export const offerPricePromoCss = css({
  textStyle: { base: 'body-20', lg: 'body-18' },
  color: 'red-100',
})

export const strikePriceCss = css({
  textStyle: { base: 'body-20', lg: 'body-18' },
  color: 'mediumgray',
  textDecoration: 'line-through',
  textDecorationSkipInk: 'none',
})

// Bundle keeps the mobile size on desktop too.
export const priceBundleCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-2',
  textStyle: 'body-20',
  color: 'black',
})

export const strikePriceBundleCss = css({
  textStyle: 'body-20',
  color: 'mediumgray',
  textDecoration: 'line-through',
  textDecorationSkipInk: 'none',
})

export const srOnlyCss = css({ srOnly: true })

export const captionCss = css({
  textStyle: 'body-12',
  color: 'mediumgray',
  width: 'full',
})

export const tagsCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-6',
})

export const servingCss = css({
  display: 'flex',
  alignItems: 'center',
  textStyle: 'body-12',
  color: 'black',
})

export const servingWrapperCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-2',
})

export const servingStrikePriceCss = css({
  textStyle: 'body-12',
  color: 'mediumgray',
  textDecoration: 'line-through',
  textDecorationSkipInk: 'none',
})
